module.exports = __webpack_public_path__ + "static/Freight-BigLight-f07ab48c0b31ae98f6bf424c1742ee50.ttf";